import { getPrimaryValueGroup } from 'stores/selectedValueGroupsStore/getPrimaryValueGroup'
import { selectedValueGroupsStore } from 'stores/selectedValueGroupsStore/selectedValueGroupsStore'

export const usePrimaryValueGroup = () => {
  const primaryValueGroup = selectedValueGroupsStore.useSelector(getPrimaryValueGroup)

  return primaryValueGroup
}
